<template>
  <ContentContainer>
    <section class="grid lg:gap-[42px] gap-[36px] py-[36px] lg:py-21">
      <slot name="content" />
    </section>
  </ContentContainer>
</template>

<script setup lang="ts">
import { provide, ref } from 'vue';

const { alternateDirection = '0' } = defineProps<{
  alternateDirection?: '1' | '0';
}>();

defineSlots<{
  content(): any;
}>();

const childCounter = ref(0);
provide('alternateDirection', alternateDirection);
provide('alternateChildCounter', childCounter);
</script>
